/** Mensagem que o backend mandou no erro do RTK (`{ status, data: { mensagem } }`); null quando não veio nenhuma. */
export function mensagemDoErro(err: unknown): string | null {
  if (typeof err !== 'object' || err === null || !('data' in err)) return null

  const mensagem = (err as { data?: { mensagem?: unknown } }).data?.mensagem
  return typeof mensagem === 'string' && mensagem.trim() ? mensagem : null
}
